import {
  ContentEditorQuestionCatalogueIndexResponse,
  ContentEditorQuestionCataloguesQuestionCatalogueCategory,
  ContentEditorQuestionCataloguesQuestionCatalogueCategoryIndexResponse,
  ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInner,
  ContentEditorShowResponse,
  ContentEditorTestDefinitionEntryIndexResponse,
  ContentEditorTestDefinitionIndexResponse,
  ContentEditorTestDefinitionIndexResponseQuestionsInnerDependentStepsInner,
  ContentEditorUploadedFileMap,
  ContentEditorValidationErrorIndexResponse,
  QuestionCatalogueQuestionUpdate,
  QuestionUpdate,
  UploadedFile
} from "generated-api";
import {AppDispatch} from "index";
import {uploadFile as uploadPublicOrPrivateFile} from "./upload";

export interface HtmlType {
  content: string;
}

export interface CatalogueType extends ContentEditorQuestionCatalogueIndexResponse {

}

export interface TestType extends ContentEditorTestDefinitionIndexResponse {
  entries?: TestEntryType[]
}

export interface TestEntryType extends ContentEditorTestDefinitionEntryIndexResponse {
}

export interface VersionsType extends ContentEditorShowResponse {
}

export interface QuestionType extends QuestionUpdate {
  id: number;
  choices?: ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInner[];
  file?: ContentEditorUploadedFileMap;
  dependent_steps?: ContentEditorTestDefinitionIndexResponseQuestionsInnerDependentStepsInner[];
  question_catalogue_categories?: ContentEditorQuestionCataloguesQuestionCatalogueCategory[];
}

export interface CatalogueQuestionType extends QuestionType, QuestionCatalogueQuestionUpdate {
  status?: string;
}

export interface ChoiceType extends ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInner {
}

export interface CatalogueCategoryType extends ContentEditorQuestionCataloguesQuestionCatalogueCategoryIndexResponse {
}

export interface QuestionErrorType extends ContentEditorValidationErrorIndexResponse {

}

export interface DragItem {
  index: number;
  id: string;
  type: string;
  targetIndex: number;
}

export const broadcastNgEditorSuccessEvent = () => {
  try {
    // needed to trigger global "_validateVersions"
    const element = (window as any)['angular'].element(document.body);
    const scope = element.scope();
    scope.$root.$broadcast("$contentEditorSuccess");
  } catch (ignored) {

  }
}

export const sortByPosition = (a: { position: number }, b: { position: number }) => {
  return (a.position > b.position) ? 1 : (a.position === b.position ? 0 : -1);
}

// shared by choice cells and the "add choice" cell, which must stay aligned
export const choiceGridSize = (question: QuestionType) => {
  const isImage = question.response_type === 'image';
  return {
    xl: isImage ? (question.file?.id ? 6 : 4) : 12,
    lg: isImage ? (question.file?.id ? 12 : 6) : 12,
    md: 12,
  };
}

export const uploadFile = (dispatch: AppDispatch, file: File): Promise<UploadedFile | undefined> =>
  uploadPublicOrPrivateFile(dispatch, file, true);
